<template>
    <el-dialog
            :title="'详情'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form  ref="dataForm"
                  label-width="150px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="部门" prop="bmmc">
                        <div class="min-input-class">{{dataForm.bmmc}}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="岗点" prop="gdmc">
                        <div class="min-input-class">{{dataForm.gdmc}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="二维码数量" prop="codeNum">
                <el-input-number :disabled="true" v-model="dataForm.codeNum" ></el-input-number>
            </el-form-item>
                </el-col>
            </el-row>
            <el-scrollbar class="scrollbar-wrapper" style="height:300px;">
                <el-row v-for="(item,index) in dataForm.codeNum"  :key="index">
                <el-col :span="12">
                    <el-form-item label="名称" >
                        <div>{{ dataForm.bmmc+'-'+dataForm.gdmc+'-'+(index+1) }}</div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                    <el-popover
  placement="top-start"
  width="300"
  trigger="click">
  <vue-qrcode  :value="dataForm.id+','+dataForm.bmmc+'-'+dataForm.gdmc+'-'+(index+1)"  :options="{ width: 300 }"></vue-qrcode>
  <div slot="reference" style="color:aqua">点击查看二维码</div>
  </el-popover>
                    </el-form-item>
                </el-col>
            </el-row>
	</el-scrollbar>  
            
        </el-form>
        <span slot="footer" class="dialog-footer">
<!--            <el-button @click="downloadCanvasIamge">下载</el-button>-->
      <el-button @click="visible = false">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import VueQrcode from '@chenfengyuan/vue-qrcode';
    export default {
        components: {VueQrcode},
        data () {
            return {
                visible: false,
                dataForm: {},
            }
        },
        methods: {
            init (obj) {
                if(!obj) return;
                this.visible = true
                this.$nextTick(() => {
                    this.dataForm = obj
                })

            },
            downloadCanvasIamge(selector, name) {
         // 通过选择器获取canvas元素
                // 通过选择器获取canvas元素
          var canvas = document.querySelector("canvas")
                // 使用toDataURL方法将图像转换被base64编码的URL字符串
         // 使用toDataURL方法将图像转换被base64编码的URL字符串
         var url = canvas.toDataURL('image/png')
         // 生成一个a元素
         var a = document.createElement('a')
         // 创建一个单击事件
         var event = new MouseEvent('click')

         // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
         a.download = this.dataForm.name
         // 将生成的URL设置为a.href属性
         a.href = url

         // 触发a的单击事件
         a.dispatchEvent(event)
    }
        }
    }
</script>
<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
</style>
